module.exports = __webpack_public_path__ + "img/ss_pink-08.dca0c5e2.jpg";